import React, {useMemo, useState} from 'react';
import {NavLink, useLocation} from "react-router-dom";
import {observer} from "mobx-react-lite";
import ROUTES from "../../routes";
import styles from './styles.module.scss';
import useQCompanies from "../../queries/useQCompanies";
import useQProfile from "../../queries/useQProfile";
import CompanyObserver from "../../mobx/company/CompanyObserver";
import {EnumModules} from "../../resources/IProfile.resource";
import useHasChecklistManagementAccess from "../../hooks/useHasChecklistManagementAccess";

const AutomaticMark = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M20.25 11.25C20.6642 11.25 21 11.5858 21 12V16.5C21 16.9142 20.6642 17.25 20.25 17.25C19.8358 17.25 19.5 16.9142 19.5 16.5V12C19.5 11.5858 19.8358 11.25 20.25 11.25Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M17.25 14.25C17.25 13.8358 17.5858 13.5 18 13.5H22.5C22.9142 13.5 23.25 13.8358 23.25 14.25C23.25 14.6642 22.9142 15 22.5 15H18C17.5858 15 17.25 14.6642 17.25 14.25Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M7.875 3C8.28921 3 8.625 3.33579 8.625 3.75V7.5C8.625 7.91421 8.28921 8.25 7.875 8.25C7.46079 8.25 7.125 7.91421 7.125 7.5V3.75C7.125 3.33579 7.46079 3 7.875 3Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M5.25 5.625C5.25 5.21079 5.58579 4.875 6 4.875H9.75C10.1642 4.875 10.5 5.21079 10.5 5.625C10.5 6.03921 10.1642 6.375 9.75 6.375H6C5.58579 6.375 5.25 6.03921 5.25 5.625Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M15.75 16.5C16.1642 16.5 16.5 16.8358 16.5 17.25V20.25C16.5 20.6642 16.1642 21 15.75 21C15.3358 21 15 20.6642 15 20.25V17.25C15 16.8358 15.3358 16.5 15.75 16.5Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M13.5 18.75C13.5 18.3358 13.8358 18 14.25 18H17.25C17.6642 18 18 18.3358 18 18.75C18 19.1642 17.6642 19.5 17.25 19.5H14.25C13.8358 19.5 13.5 19.1642 13.5 18.75Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M3.00597 19.0597C2.42019 18.4739 2.42019 17.5241 3.00597 16.9384L16.947 2.99731C17.5328 2.41152 18.4826 2.41152 19.0683 2.99731L21.0074 4.93633C21.5932 5.52212 21.5931 6.47186 21.0074 7.05765L7.06631 20.9987C6.48053 21.5845 5.53078 21.5845 4.94499 20.9987L3.00597 19.0597ZM18.0077 4.05797L4.06663 17.999L6.00565 19.938L19.9467 5.99699L18.0077 4.05797Z"
                  fill="#1E1E1E"/>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12.9697 6.96967C13.2626 6.67678 13.7374 6.67678 14.0303 6.96967L17.0303 9.96967C17.3232 10.2626 17.3232 10.7374 17.0303 11.0303C16.7374 11.3232 16.2626 11.3232 15.9697 11.0303L12.9697 8.03033C12.6768 7.73744 12.6768 7.26256 12.9697 6.96967Z"
                  fill="#1E1E1E"/>
        </svg>
    )
}
const DashboardIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.92857 4.28571C4.575 4.28571 4.28571 4.575 4.28571 4.92857V8.78571C4.28571 9.13929 4.575 9.42857 4.92857 9.42857H8.78571C9.13929 9.42857 9.42857 9.13929 9.42857 8.78571V4.92857C9.42857 4.575 9.13929 4.28571 8.78571 4.28571H4.92857ZM3 4.92857C3 3.86384 3.86384 3 4.92857 3H8.78571C9.85045 3 10.7143 3.86384 10.7143 4.92857V8.78571C10.7143 9.85045 9.85045 10.7143 8.78571 10.7143H4.92857C3.86384 10.7143 3 9.85045 3 8.78571V4.92857ZM4.92857 14.5714C4.575 14.5714 4.28571 14.8607 4.28571 15.2143V19.0714C4.28571 19.425 4.575 19.7143 4.92857 19.7143H8.78571C9.13929 19.7143 9.42857 19.425 9.42857 19.0714V15.2143C9.42857 14.8607 9.13929 14.5714 8.78571 14.5714H4.92857ZM3 15.2143C3 14.1496 3.86384 13.2857 4.92857 13.2857H8.78571C9.85045 13.2857 10.7143 14.1496 10.7143 15.2143V19.0714C10.7143 20.1362 9.85045 21 8.78571 21H4.92857C3.86384 21 3 20.1362 3 19.0714V15.2143ZM19.0714 4.28571H15.2143C14.8607 4.28571 14.5714 4.575 14.5714 4.92857V8.78571C14.5714 9.13929 14.8607 9.42857 15.2143 9.42857H19.0714C19.425 9.42857 19.7143 9.13929 19.7143 8.78571V4.92857C19.7143 4.575 19.425 4.28571 19.0714 4.28571ZM15.2143 3H19.0714C20.1362 3 21 3.86384 21 4.92857V8.78571C21 9.85045 20.1362 10.7143 19.0714 10.7143H15.2143C14.1496 10.7143 13.2857 9.85045 13.2857 8.78571V4.92857C13.2857 3.86384 14.1496 3 15.2143 3ZM15.2143 14.5714C14.8607 14.5714 14.5714 14.8607 14.5714 15.2143V19.0714C14.5714 19.425 14.8607 19.7143 15.2143 19.7143H19.0714C19.425 19.7143 19.7143 19.425 19.7143 19.0714V15.2143C19.7143 14.8607 19.425 14.5714 19.0714 14.5714H15.2143ZM13.2857 15.2143C13.2857 14.1496 14.1496 13.2857 15.2143 13.2857H19.0714C20.1362 13.2857 21 14.1496 21 15.2143V19.0714C21 20.1362 20.1362 21 19.0714 21H15.2143C14.1496 21 13.2857 20.1362 13.2857 19.0714V15.2143Z"
            fill="black"/>
    </svg>
)

const CheckListIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M15.4202 6.67519C14.3242 6.22494 13.1502 5.99551 11.9654 6.00007L11.9651 6.00007C7.00717 6.01734 3 10.1156 3 15.1032V17.2501H21V15.0001C21 13.8153 20.7661 12.6421 20.3116 11.5479C19.8572 10.4537 19.1911 9.46002 18.3517 8.62384C17.5123 7.78766 16.5161 7.12544 15.4202 6.67519ZM11.9599 4.50008C13.3421 4.4948 14.7117 4.76246 15.9902 5.28772C17.2688 5.81302 18.4311 6.5856 19.4104 7.56114C20.3897 8.53669 21.1667 9.69599 21.6969 10.9726C22.2271 12.2491 22.5 13.6178 22.5 15.0001V17.2501C22.5 17.6479 22.342 18.0294 22.0607 18.3107C21.7794 18.592 21.3978 18.7501 21 18.7501H3C2.60218 18.7501 2.22065 18.592 1.93934 18.3107C1.65803 18.0294 1.5 17.6479 1.5 17.2501V15.1032C1.5 9.30966 6.15519 4.52045 11.9596 4.50008"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M12 4.5C12.4142 4.5 12.75 4.83579 12.75 5.25V8.25C12.75 8.66421 12.4142 9 12 9C11.5858 9 11.25 8.66421 11.25 8.25V5.25C11.25 4.83579 11.5858 4.5 12 4.5Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M1.85383 12.2838C1.96096 11.8836 2.37216 11.6461 2.77228 11.7532L5.67853 12.5314C6.07866 12.6385 6.31617 13.0497 6.20904 13.4498C6.10191 13.8499 5.69071 14.0875 5.29059 13.9803L2.38434 13.2022C1.98422 13.0951 1.7467 12.6839 1.85383 12.2838Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M22.1465 12.2838C22.2537 12.6839 22.0162 13.0951 21.616 13.2022L18.7098 13.9803C18.3097 14.0875 17.8985 13.8499 17.7913 13.4498C17.6842 13.0497 17.9217 12.6385 18.3218 12.5314L21.2281 11.7532C21.6282 11.6461 22.0394 11.8836 22.1465 12.2838Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16.5631 9.05161C16.8917 9.30384 16.9535 9.77466 16.7013 10.1032L10.2888 18.4563C10.0366 18.7849 9.56575 18.8468 9.23718 18.5946C8.90862 18.3423 8.84674 17.8715 9.09897 17.5429L15.5115 9.18982C15.7637 8.86126 16.2345 8.79938 16.5631 9.05161Z"
              fill="#1E1E1E"/>
    </svg>
)

const ChecklistManagementIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M5 4C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V5C20 4.44772 19.5523 4 19 4H5ZM2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M7 16C7 15.4477 7.44772 15 8 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H8C7.44772 17 7 16.5523 7 16Z"
              fill="#1E1E1E"/>
    </svg>
)

const AuditSimilarityIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M4 4C4 3.44772 4.44772 3 5 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289L19.7071 8.29289C19.8946 8.48043 20 8.73478 20 9V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V4ZM6 5V19H18V10H13C12.4477 10 12 9.55228 12 9V5H6ZM14 6.41421L16.5858 9H14V6.41421Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8 13C8 12.4477 8.44772 12 9 12H15C15.5523 12 16 12.4477 16 13C16 13.5523 15.5523 14 15 14H9C8.44772 14 8 13.5523 8 13Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8 17C8 16.4477 8.44772 16 9 16H12C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H9C8.44772 18 8 17.5523 8 17Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M14.7071 15.2929C15.0976 15.6834 15.0976 16.3166 14.7071 16.7071L13.4142 18L14.7071 19.2929C15.0976 19.6834 15.0976 20.3166 14.7071 20.7071C14.3166 21.0976 13.6834 21.0976 13.2929 20.7071L11.2929 18.7071C10.9024 18.3166 10.9024 17.6834 11.2929 17.2929L13.2929 15.2929C13.6834 14.9024 14.3166 14.9024 14.7071 15.2929Z"
              fill="#1E1E1E"/>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M16.2929 15.2929C16.6834 14.9024 17.3166 14.9024 17.7071 15.2929L19.7071 17.2929C20.0976 17.6834 20.0976 18.3166 19.7071 18.7071L17.7071 20.7071C17.3166 21.0976 16.6834 21.0976 16.2929 20.7071C15.9024 20.3166 15.9024 19.6834 16.2929 19.2929L17.5858 18L16.2929 16.7071C15.9024 16.3166 15.9024 15.6834 16.2929 15.2929Z"
              fill="#1E1E1E"/>
    </svg>
)

const CloseIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M16.7071 9.29289C16.3166 8.90237 15.6834 8.90237 15.2929 9.29289L9.29289 15.2929C9.10536 15.4804 9 15.7348 9 16C9 16.2652 9.10536 16.5196 9.29289 16.7071L15.2929 22.7071C15.6834 23.0976 16.3166 23.0976 16.7071 22.7071C17.0976 22.3166 17.0976 21.6834 16.7071 21.2929L11.4142 16L16.7071 10.7071C17.0976 10.3166 17.0976 9.68342 16.7071 9.29289Z"
                  fill="#1E1E1E"/>
            <path
                d="M17 16C17 16.5523 17.4477 17 18 17C18.5523 17 19 16.5523 19 16C19 15.4477 18.5523 15 18 15C17.4477 15 17 15.4477 17 16Z"
                fill="#1E1E1E"/>
            <path
                d="M21 16C21 16.5523 21.4477 17 22 17C22.5523 17 23 16.5523 23 16C23 15.4477 22.5523 15 22 15C21.4477 15 21 15.4477 21 16Z"
                fill="#1E1E1E"/>
        </svg>
    )
}


const OpenIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289L22.7071 15.2929C22.8946 15.4804 23 15.7348 23 16C23 16.2652 22.8946 16.5196 22.7071 16.7071L16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071C14.9024 22.3166 14.9024 21.6834 15.2929 21.2929L20.5858 16L15.2929 10.7071C14.9024 10.3166 14.9024 9.68342 15.2929 9.29289Z"
                  fill="#1E1E1E"/>
            <path
                d="M15 16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15C14.5523 15 15 15.4477 15 16Z"
                fill="#1E1E1E"/>
            <path
                d="M11 16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16C9 15.4477 9.44772 15 10 15C10.5523 15 11 15.4477 11 16Z"
                fill="#1E1E1E"/>
        </svg>
    )
}


const SideBar = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const location = useLocation();
    const { companies } = useQCompanies();
    const { profile } = useQProfile();
    const handleToggleOpen = () => setIsOpen((prev) => !prev);

    const companyId = CompanyObserver.companyId ?? CompanyObserver.getCompanyId();

    const showAuditMenu = useMemo(() => {
        if (!companies || !profile || !companyId) return false;
        const company = companies.companies.find((item) => item.id === companyId);
        return (company?.modules.includes(EnumModules.PHONE_CALL_AUTO) ?? false) &&
            profile.modules.includes(EnumModules.AUDIT);
    }, [companies, profile, companyId]);

    const {hasAccess: showChecklistManagementMenu} = useHasChecklistManagementAccess();

    const itemClassNameBuilder = (route: string) => `${styles.sidebar__item} ${route === location.pathname ? styles.sidebar__item_active : ''}`;

    return (
        <div className={`${styles.sidebar} ${!isOpen ? styles.sidebar__closed : ''}`}>
            <button
                className={styles.sidebar__btn}
                onClick={handleToggleOpen}
            >
                {isOpen ? <CloseIcon/> : <OpenIcon/>}
            </button>
            <div className={styles.sidebar__list}>
                <ul className={styles.sidebar__menu}>
                    <li
                        className={itemClassNameBuilder(ROUTES.DASHBOARD)}
                        title={'Dashboard'}
                    >
                        <NavLink
                            to={ROUTES.DASHBOARD}
                            className={styles.sidebar__link}
                        >
                            <div className={styles.sidebar__icon}>
                                <DashboardIcon/>
                            </div>
                            {isOpen ? 'Dashboard' : ''}
                        </NavLink>
                    </li>
                    <li
                        className={itemClassNameBuilder(ROUTES.HOME)}
                        title={'Автоматична оцінка'}
                    >
                        <NavLink
                            to={ROUTES.HOME}
                            className={styles.sidebar__link}

                        >
                            <div className={styles.sidebar__icon}>
                                <AutomaticMark/>
                            </div>
                            {isOpen ? 'Автоматична оцінка' : ''}
                        </NavLink>
                    </li>
                    <li
                        className={itemClassNameBuilder(ROUTES.CHECK_LIST)}
                        title={'Аналітика'}
                    >
                        <NavLink
                            to={ROUTES.CHECK_LIST}
                            className={styles.sidebar__link}
                        >
                            <div className={styles.sidebar__icon}>
                                <CheckListIcon/>
                            </div>
                            {isOpen ? 'Аналітика' : ''}
                        </NavLink>
                    </li>
                    {showChecklistManagementMenu && (
                        <li
                            className={itemClassNameBuilder(ROUTES.CHECKLIST_MANAGEMENT)}
                            title={'Чеклісти'}
                        >
                            <NavLink
                                to={ROUTES.CHECKLIST_MANAGEMENT}
                                className={styles.sidebar__link}
                            >
                                <div className={styles.sidebar__icon}>
                                    <ChecklistManagementIcon/>
                                </div>
                                {isOpen ? 'Чеклісти' : ''}
                            </NavLink>
                        </li>
                    )}
                    {showAuditMenu && (
                        <li
                            className={itemClassNameBuilder(ROUTES.CHECK_LIST_AUDIT)}
                            title={'Аудит схожості'}
                        >
                            <NavLink
                                to={ROUTES.CHECK_LIST_AUDIT}
                                className={styles.sidebar__link}
                            >
                                <div className={styles.sidebar__icon}>
                                    <AuditSimilarityIcon/>
                                </div>
                                {isOpen ? 'Аудит схожості' : ''}
                            </NavLink>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default observer(SideBar);
